import {
  ApiResponse,
  TicketManagerMember,
  TicketManagerMemberRole,
  TicketManagerMemberUser,
} from '@vision/ui/interfaces';

export interface TicketManagerMemberUserResponseDto {
  email?: string;
  full_name?: string;
  id?: string;
  name?: string;
  surname?: string;
}

export interface TicketManagerMemberResponseDto {
  id: string;
  role: TicketManagerMemberRole;
  user?: TicketManagerMemberUserResponseDto | null;
  created_at?: string;
}

function normalizeTicketManagerMemberUser(dto: TicketManagerMemberUserResponseDto): TicketManagerMemberUser {
  return {
    email: dto.email || '',
    fullName: dto.full_name || dto.email || '',
    id: dto.id || '',
    name: dto.name || '',
    surname: dto.surname || '',
  };
}

export function normalizeTicketManagerMember(dto: TicketManagerMemberResponseDto): TicketManagerMember {
  const normalizedUser = dto.user ? normalizeTicketManagerMemberUser(dto.user) : normalizeTicketManagerMemberUser({});

  return {
    id: dto.id,
    role: dto.role,
    user: normalizedUser,
    userId: normalizedUser.id,
    ...(dto.created_at !== undefined && { createdAt: dto.created_at }),
  };
}

export function normalizeTicketManagerMembersResponse(
  response: ApiResponse<TicketManagerMemberResponseDto[]>,
): ApiResponse<TicketManagerMember[]> {
  return {
    ...response,
    data: response.data.map(normalizeTicketManagerMember),
  };
}
